<template
  ><div style="padding-top:-2px;margin-top:-2px;">
    <v-label
      ><b>{{ label }}</b></v-label
    >
    <s-select-generic
      autocomplete
      class="text"
      itemvalue="NtpSuperviceID"
      :disabled="disabled"
      :value="value"
      id="NtpID" itemtext="Supervice"
      :return-object="returnObject"
      @input="input($event)"
      :config="config"
      :full="full"
      :text="text"
      :clearable="clearable"
      no-default
    >

    /* NtpSuperviceID
    NtpID */
    </s-select-generic>

    
  </div>
</template>



<script>
import _sService from "@/services/Technicalassistance/HarvestSchedule.js";
export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    value: null,
    text: { type: String, default: "" },
    label: {
      type: String,
      default: "",
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
    produceID:{
      type: Number,
      default: 0,
    },
    position:{
      type: Number,
      default: 0,
    },
    noDefault: {
      type: Boolean,
      default: false,
    },    
    full: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value(value) {
      this.item = value;
    },
    produceID(){
        this.config.params.SpvId=this.produceID
    }
  },
  methods: {
    input(val) {
      this.$emit("input", val);
    },
  },
  data: () => ({
    item: 0,
    val: "",
    items: [],
    config: {},
  }),

  created() {
    this.config = {
      url: _sService.getUrlListSupervice(),
      title: this.label,
      params: { search: "", requestID: this.$fun.getUserID(), SpvId: this.position},
    };
  },
};
</script>
